document.addEventListener('DOMContentLoaded', () => {
  const accountMenus = document.querySelectorAll('.erbatab-account-menu');

  accountMenus.forEach((menu) => {
    const trigger = menu.querySelector('.erbatab-account-trigger');
    const dropdown = menu.querySelector('.erbatab-account-dropdown');

    if (!trigger || !dropdown) return;

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const willOpen = !menu.classList.contains('is-open');

      accountMenus.forEach((otherMenu) => {
        otherMenu.classList.remove('is-open');

        const otherTrigger = otherMenu.querySelector(
          '.erbatab-account-trigger'
        );

        otherTrigger?.setAttribute('aria-expanded', 'false');
      });

      if (willOpen) {
        menu.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.addEventListener('click', (event) => {
    accountMenus.forEach((menu) => {
      if (!menu.contains(event.target)) {
        menu.classList.remove('is-open');

        menu
          .querySelector('.erbatab-account-trigger')
          ?.setAttribute('aria-expanded', 'false');
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    accountMenus.forEach((menu) => {
      menu.classList.remove('is-open');

      const trigger = menu.querySelector('.erbatab-account-trigger');
      trigger?.setAttribute('aria-expanded', 'false');
      trigger?.focus();
    });
  });
});